import { makeStyles } from '@material-ui/core/styles';
import { THEME_VARIANTS } from 'core/components/theme/theme-variant';

// The global disabled colors are for dark panels; on light cards they match the background.
const lightDisabled = (theme) =>
  theme.themeVariant === THEME_VARIANTS.RESKIN ? { '&.Mui-disabled': { color: theme.colors.text_secondary } } : {};

const styles = (theme) => ({
  label: {
    color: theme.colors.light_text,
    display: 'inline',
    '&.Mui-disabled': {
      color: theme.colorPalette.beige_25,
      opacity: 0.6
    }
  },
  container: {
    minHeight: 39,
    cursor: 'pointer',
    marginBottom: 0
  },
  'light-label': {
    color: theme.colors.text_secondary,
    display: 'inline',
    ...lightDisabled(theme)
  },
  'light-checkboxColorPrimary': {
    color: theme.colors.text_secondary,
    ...lightDisabled(theme)
  },
  lightControlLabel:
    theme.themeVariant === THEME_VARIANTS.RESKIN
      ? { '&.Mui-disabled': { color: theme.colors.text_secondary, opacity: 0.7 } }
      : {},
  'dark-label': {
    color: `${theme.colors.light_text} !important`,
    '&.Mui-disabled': {
      color: theme.colorPalette.beige_25,
      opacity: 0.6
    }
  },
  // Reskin: cards are light, so boxes that sat on dark cards get the neutral ring and a bark check.
  onDarkColorPrimary:
    theme.themeVariant === THEME_VARIANTS.RESKIN
      ? {
          color: theme.colorPalette.beige_90,
          '&.Mui-checked': {
            color: theme.colors.selection_control
          },
          '&.Mui-checked::before': {
            backgroundColor: theme.colorPalette.white
          }
        }
      : {},
  'dark-checkboxRoot': {
    height: 'auto'
  },
  lightCheckboxLongLabel: {
    height: 'auto',
    alignSelf: 'baseline',
    color: theme.colors.text_secondary,
    ...lightDisabled(theme)
  },
  darkCheckboxLongLabel: {
    height: 'auto',
    alignSelf: 'baseline',
    color: theme.colors.text_primary
  },
  error: {
    color: `${theme.colors.error} !important`
  },
  checkboxLongLabelError: {
    height: 'auto',
    alignSelf: 'baseline',
    paddingTop: theme.spacing(2),
    color: `${theme.colors.error} !important`
  },
  helperText: {
    display: 'none'
  }, // For overriding
  // #33448: opt-in visible variant so error helper text can be surfaced (default stays hidden above).
  visibleHelperText:
    theme.themeVariant === THEME_VARIANTS.RESKIN
      ? {
          '&.Mui-error': {
            color: theme.colors.error
          }
        }
      : { color: theme.colorPalette.red_50 },
  customControlLabel: {
    alignSelf: 'flex-start',
    flex: 'auto'
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  subLabel: {
    marginTop: theme.spacing(0.5),
    color: theme.colorPalette.green_75,
    fontSize: 12,
    fontWeight: 400
  },
  description: {
    color: theme.colorPalette.green_75,
    marginTop: theme.spacing(1)
  }
});

export default makeStyles(styles);
